export default __webpack_public_path__ + "static/media/like_icon.113b9f87.svg";